import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
import { JwtPayloadAssist } from '../models/JwtPayloadAssist';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    protected http: HttpClient,
    @Inject('BASE_URL') protected baseUrl: string,
    @Inject('LOGIN_URL') protected loginUrl: string,
    @Inject('APP_KEY') protected appKey: string,
    private router: Router
  ) {} // ...

  getAppKey() {
    return this.appKey;
  }

  public getLoginUrl(returnUrl: string) {
    return this.loginUrl + '?key=' + this.appKey + '&returnurl=' + encodeURIComponent(returnUrl);
  }

  public getToken(): string {
    var token = localStorage.getItem('accessKey');
    return token != null ? token : '';
  }

  public isAuthenticated(): boolean {
    const token = this.getToken(); // Check whether the token is expired and return

    // true or false
    if (token && token.length > 100) return true;
    else return false;
  }

  public getTokenPayload(): JwtPayloadAssist {
    return jwt_decode<JwtPayloadAssist>(this.getToken());
  }

  public signOut(routeToNavigate: string | null = '/') {
    this.http.get<boolean>(this.baseUrl + 'user/public/signout').subscribe(() => {
      localStorage.removeItem('accessKey');
      if (!routeToNavigate) routeToNavigate = '/';
      this.router.navigateByUrl(routeToNavigate).then(() => {
        window.location.reload();
      });
    });
  }
}
